import React, { useRef, useEffect } from 'react';

interface ICheckboxProps {
    // attributes
    analytics?: string;
    isChecked?: boolean;
    isDark?: boolean;
    isDisabled?: boolean;
    hasError?: boolean;
    shouldHideRequiredLabelling?: boolean;
    identifier?: string;
    name?: string;
    isRequired?: boolean;
    value: string;
    label: string;
    // events
    onChange?: (value: string) => void;
    // extra nous
    dataTestId?: string;
}

export const Radio: React.FC<ICheckboxProps> = ({
    // attributes
    analytics,
    isChecked,
    isDark,
    isDisabled,
    hasError,
    shouldHideRequiredLabelling = true,
    identifier,
    name,
    isRequired,
    value,
    label,
    // events
    onChange,
    // extra nous
    dataTestId
}) => {
    const ref = useRef(null);

    // evenement seulement triggered quand le radio est checked
    const handleRadioChange = (newValue: string) => {
        onChange(newValue);
    };

    useEffect(() => {
        ref.current.addEventListener('dsdRadioChange', (e) => {
            if (onChange) handleRadioChange(e?.detail?.value);
        });
    }, []);

    return (
        // @ts-ignore
        <dsd-radio
            ref={ref}
            data-testid={dataTestId}
            analytics={analytics}
            checked={isChecked}
            dark={isDark}
            disabled={isDisabled}
            error={hasError}
            hideRequiredLabelling={shouldHideRequiredLabelling}
            identifier={identifier}
            name={name}
            required={isRequired}
            value={value}
        >
            {label}
            {/* @ts-ignore */}
        </dsd-radio>
    );
};
